export const POS_TRANSLATION_NAMESPACE = "pos";

export const POS_DETAILS_TK = "POS_DETAILS_TK";

export const POS_CHANNEL_INFO_TAB_TK = "POS_CHANNEL_INFO_TAB_TK";
export const POS_CHANNEL_MAPPING_TAB_TK = "POS_CHANNEL_MAPPING_TAB_TK";
export const POS_OTHER_SETTINGS_TAB_TK = "POS_OTHER_SETTINGS_TAB_TK";
export const POS_PLATFORM_CONNECTION_TAB_TK = "POS_PLATFORM_CONNECTION_TAB_TK";
export const POS_DETAILS_TAB_TK = "POS_DETAILS_TAB_TK";
export const POS_IMPACTED_OFFERS_TK = "POS_IMPACTED_OFFERS_TK";
export const POS_OPENING_HOURS_TK = "POS_OPENING_HOURS_TK";

export const POS_LIST_TK = "POS_LIST_TK";
